var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupplierArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9074 10.1379H9.94464V1.70765C9.94464 1.38736 9.82362 1.08019 9.60819 0.853712C9.39276 0.627234 9.10057 0.5 8.79591 0.5C8.64527 0.499999 8.49611 0.531269 8.35698 0.592016C8.21786 0.652763 8.09152 0.741791 7.9852 0.853993C7.87889 0.966195 7.79469 1.09936 7.73745 1.24585C7.6802 1.39234 7.65104 1.54928 7.65162 1.70765V14.297C7.65162 14.6161 7.77218 14.9221 7.98678 15.1477C8.20137 15.3733 8.49243 15.5 8.79591 15.5H8.86688H8.96002H9.06646H9.08864C9.30421 15.4401 9.49845 15.3153 9.64748 15.141C10.2241 14.5348 10.8184 13.1919 13.1957 10.6368C13.311 10.427 13.1291 10.1379 12.9074 10.1379Z",
    fill: "#354ACD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.895836 5.86214H3.85858V14.2924C3.85858 14.6126 3.97961 14.9198 4.19504 15.1463C4.41046 15.3728 4.70265 15.5 5.00731 15.5C5.15795 15.5 5.30712 15.4687 5.44624 15.408C5.58536 15.3472 5.7117 15.2582 5.81802 15.146C5.92433 15.0338 6.00853 14.9006 6.06577 14.7541C6.12302 14.6077 6.15219 14.4507 6.1516 14.2924V1.70298C6.1516 1.38393 6.03104 1.07795 5.81645 0.852345C5.60185 0.626742 5.31079 0.5 5.00731 0.5H4.93635H4.8432H4.73676H4.71458C4.49901 0.559881 4.30477 0.684669 4.15574 0.85903C3.57916 1.46518 2.98484 2.80805 0.607545 5.36323C0.492229 5.57305 0.674074 5.86214 0.895836 5.86214Z",
    fill: "#354ACD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupplierArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/supplierArrow.e84f04342a17392009a73f211ecabea4.svg";